export const SessionEnum = Object.freeze({
    history: "history",
    selectedLayers: "selectedLayers",
    closeUseInApp: "closeUseInApp",
    layer:'layer'
})